//====================================================
//  Initialization process svg
//====================================================

function fn_components_vivus(){
	if ($('.js-checkpoint').length){
		//new Vivus('process-svg', {duration: 200}, myCallback);
		$('.js-checkpoint').waypoint({
			handler: function(direction) {
				// new Vivus('js-checkpoint', {
				// 	duration: 200, 
				// 	file: 'images/icons/ciara-kratka-1.svg',
				// 	// type: 'scenario',
				// 	onReady: function (myVivus) {
				// 		console.log("asds");
				// 	    myVivus.play(1);
				// 	}
				// }, function(){
				// 	$('.js-checkpoint').addClass('end');
				// });

				$(this.element).addClass( class_active );
				this.destroy();
		  	},
 			offset: '70%'
		})
	}
}